export enum EmployeesPaginationParam {
  Page = 'page',
  PageSize = 'pageSize',
  EmployeesWithActionsPage = 'employeesWithActionsPage',
  EmployeesWithActionsPageSize = 'employeesWithActionsPageSize',
}
